<template>
 
    <div class="home">
        <div>
            <img style="width: 16%; margin-left: 18px; float:left" alt="Moresi.com" src="@/assets/logo-moresi-senza-zona-esclusione.png" />


          <!--  <img style="width: 18%; float: right; margin-right: 25px"
                 alt="Moresi.com"
                 src="@/assets/microsoft-logo-png-transparent-20.png" />-->
        </div>
        <div class="main-option">
            <h2>Host a new session</h2>
            <button @click="login">Host</button>
        </div>
        <div class="main-option">
            <h2>Join a running session</h2>
            <div>
                <button @click="join">Join</button>
            </div>
        </div>
        <div class="footer">

            <div style="text-align:center;">Copyright Moresi.com SA 2025</div>
        </div>
    </div>
</template>

<script>
import constants from '../lib/constants'

export default {
  name: 'home',
  methods: {
    login() {
      if (constants.authProvider) {
        window.location.href = `${constants.apiBaseUrl}/.auth/login/${constants.authProvider}?post_login_redirect_url=${encodeURIComponent(window.location.origin + '/host')}`
      } else {
        this.$router.push('host')
      }
    },
    join() {
      this.$router.push('join')
    }
  }
}
</script>

<style>
div.main-option {
  border: 2px solid #ddd;
  border-radius: 10px;
  padding: 24px;
  max-width: 740px;
  margin: 24px auto;
}

.main-option h2 {
  margin: 0px 0px 12px 0px;
}

.main-option button {
  padding: 12px;
  border-radius: 8px;
  width: 300px;
  font-size: 16px;
}

.main-option input[type=text] {
  padding: 0px;
  margin: 12px;
  border-radius: 8px;
  height: 48px;
  width: 300px;
  font-size: 28px;
  text-align: center;
}

.footer
{
  margin-top: 20px;
  position: relative;
  bottom: 0;
  padding: 10px;
}

.footer img
{
  width: 20%;
}
    #nav {
        position: fixed;
        top: 15px;
        width: 100%;
        min-height: 50px;
        z-index: 1000;
        background-color: #fff;
    }

</style>
